import axios from '../api/axios';
import { GROCERY_STAPLES } from './nearbyPlaces';

export const getStoreKey = (item) => {
  if (item?.storeKey) return item.storeKey;
  if (item?.placeId) return `google:${item.placeId}`;
  const slug = String(item?.name || 'store')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '');
  return `curated:${slug}`;
};

export const formatPriceInput = (value) => {
  if (value == null || value === '' || value === '—') return '';
  return String(value).replace(/[^0-9.]/g, '');
};

export const fetchGroceryStaples = async (storeKeys) => {
  const keys = [...new Set(storeKeys.filter(Boolean))];
  if (!keys.length) return {};

  const response = await axios.get('/grocery-staples', {
    params: { keys: keys.join(',') },
  });
  return response.data || {};
};

export const mergeStaplePrices = (locations, priceMap = {}) =>
  locations.map((item) => {
    const storeKey = getStoreKey(item);
    const community = priceMap[storeKey];
    if (!community) {
      return { ...item, storeKey };
    }

    const merged = { ...item, storeKey, hasCommunityPrices: true };
    GROCERY_STAPLES.forEach(({ key }) => {
      if (community[key]) {
        merged[key] = community[key];
      }
    });

    if (community.updatedBy) merged.priceUpdatedBy = community.updatedBy;
    if (community.updatedAt) merged.priceUpdatedAt = community.updatedAt;

    return merged;
  });

export const upsertGroceryStaples = (payload, accessToken) =>
  axios.put('/grocery-staples', payload, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });